import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/downlineProfile";
import { AdditionalInformationLabelKey } from "../../shared/types";

interface KeyInformationAdditionalInformationRowProps {
  label?: AdditionalInformationLabelKey;
  value?: boolean;
  configs?: {
    showAutoRenewal?: boolean;
    showContractSigned?: boolean;
    showOrderBlock?: boolean;
    showSponsorBlock?: boolean;
  };
}
const KeyInformationAdditionalInformationRow = ({
  label,
  value,
  configs,
}: KeyInformationAdditionalInformationRowProps) => {
  const { t } = useTranslation(["downlineProfile"]);

  if (label === "orderBlock" && !configs?.showOrderBlock) return null;
  if (label === "sponsorBlock" && !configs?.showSponsorBlock) return null;
  if (label === "autoRenewal" && !configs?.showAutoRenewal) return null;
  if (label === "contractSigned" && !configs?.showContractSigned) return null;

  return (
    <>
      <div className="additional-information-row">
        <span>
          {label &&
            t(
              `keyInformation.additionalInformationLabels.${label}`,
              defaultContent.keyInformation.additionalInformationLabels[label],
            )}
        </span>
        {value ? (
          <span>
            {t(
              "keyInformation.additionalInformationLabels.yes",
              defaultContent.keyInformation.additionalInformationLabels.yes,
            )}
          </span>
        ) : (
          <span>
            {t(
              "keyInformation.additionalInformationLabels.no",
              defaultContent.keyInformation.additionalInformationLabels.no,
            )}
          </span>
        )}
      </div>
    </>
  );
};

export default KeyInformationAdditionalInformationRow;
